import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output,} from "@angular/core";

require('./price-plans-bundle-hierarchy.scss');
@Component({
  standalone: false,
  selector: 'app-price-plans-bundle-hierarchy',
  templateUrl: './price-plans-bundle-hierarchy.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricePlansBundleHierarchyComponent {

  @Input() pricePlansBundleHierarchy: any;
  @Input() selectedPricePlanId: string;
  @Output() selectPricePlanEvent = new EventEmitter<string>();
  @Output() viewPricePlanDrillDownEvent = new EventEmitter<string>();


  public expandedNodesMap: any = {};

  constructor() {
  }


  onToggleNodeExpand(ixExpanded, pricePlanId) {
    this.expandedNodesMap[pricePlanId] = ixExpanded;
    this.expandedNodesMap = {...this.expandedNodesMap};
  }

}
